import moment from "moment-timezone";
import NumberUtil from "@/lib/common/number-util";

moment.tz.setDefault("Asia/Shanghai");

export default class TimeUtil {
  static readonly moment = moment;

  static humanize(seconds: number): string {
    const duration = moment.duration(seconds, "seconds");
    return (
      NumberUtil.prefixZero(duration.hours(), 2) +
      ":" +
      NumberUtil.prefixZero(duration.minutes(), 2) +
      ":" +
      NumberUtil.prefixZero(duration.seconds(), 2)
    );
  }

  static strtotime(s: string): number {
    return moment(s).unix();
  }

  static sleep(n: number): Promise<void> {
    return new Promise(resolve => {
      setTimeout(resolve, n);
    });
  }

  static formatTimeMsg(second = 0, pre = "约") {
    const m = Math.ceil(second / 60);

    return `${pre}${m}分钟`;
  }

  static formatTimeToday(time: string) {
    const currentTime = new Date();
    const year = new Date(time).getFullYear();
    const month = new Date(time).getMonth();
    const date = new Date(time).getDate();
    const hour = new Date(time).getHours();
    const min = new Date(time).getMinutes();
    // if (
    //   currentTime.getFullYear() === year &&
    //   currentTime.getMonth() === month &&
    //   currentTime.getDate() === date
    // ) {
    //   return "今天" + hour + ":" + (min < 10 ? "0" + min : min);
    // } else if (currentTime.getFullYear() === year) {
    //   return month + 1 + "月" + date + "日";
    // } else {
    //   return year + "年" + (month + 1) + "月" + date + "日";
    // }
    //需求变更：今日的不展示日期，今年的不展示年份 =》 全量展示年月日时分
    return (
      year +
      "/" +
      (month + 1) +
      "/" +
      date +
      " " +
      hour +
      ":" +
      (min < 10 ? "0" + min : min)
    );
  }

  static formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
}
